<template>
	<el-tabs v-model="activeName">
		<el-tab-pane label="调库" name="op">
			<div class="content-box">
				<edit-scheduling></edit-scheduling>
			</div>
		</el-tab-pane>
		<el-tab-pane label="调库记录" name="his">
			<his v-if="activeName=='his'" :type="[40]"></his>
		</el-tab-pane>
	</el-tabs>
</template>

<script>
import TabPage from "@/mixins/TabPage.js";
import His from "@/views/Inventory/subs/His.vue";
import EditScheduling from "@/views/Inventory/subs/EditScheduling";

export default {
	mixins: [TabPage],
	components: {
		His,
		EditScheduling
	},
	data() {
		return {
			activeName: "op"
		};
	}
};
</script>
<style lang="scss" scoped>
</style>
